export const formatDate = (rawDate : any) =>{
    if (!rawDate) return ""; 

    const date = new Date(rawDate);
    if (isNaN(date.getTime())) return ""; 
    const formatted = new Intl.DateTimeFormat("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        timeZone: "UTC" 
    }).format(new Date(rawDate));
    return formatted
}